































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { GChart } from "vue-google-charts";
import * as routes from "@/employer/route-names";
import { useDashboardStore } from "@/employer/store/dashboard";
import { useUserStore } from "@/shared/store/user";

const maxPercentage = 100;

@Component({
  components: { GChart }
})
export default class EnrollmentWidget extends Vue {
  dashboardStore = useDashboardStore();
  userStore = useUserStore();

  @Prop()
  displayHeaderLink: boolean;
  @Prop()
  displayEmployeeNavigatorContent: boolean;

  routes = routes;

  chartOptions = {
    colors: [ "#001E4B", "#244B82", "#7F9FE4" ],
    legend: { position: "top" },
    isStacked: true,
    width: "100%",
    height: "100%",
    chartArea: {
      width: "90%"
    },
    bar: {
      groupWidth: "35%"
    },
    tooltip: {
      isHtml: false
    },
    vAxis: {
      viewWindowMode: "pretty",
      textStyle: {
        color: "#041F48",
        bold: true
      }
    },
    hAxis: {
      minValue: 0,
      maxValue: 100,
      textStyle: {
        color: "#8E9398"
      },
      ticks: [
        { v: 0, f: "0%" }, { v: 25, f: "25%" }, { v: 50, f: "50%" }, { v: 75, f: "75%" }, { v: 100, f: "100%" }
      ],
      viewWindowMode: "pretty"
    }
  };

  mounted (): void {
    this.dashboardStore.initDashboard();
  }

  @Watch("userStore.employerId")
  @Watch("userStore.currentEmployer")
  onEmployerIdChange () {
    this.dashboardStore.initDashboard();
  }

  get totalAmount (): number {
    return this.dashboardStore.enrollment.total;
  }

  get enrolledAmount (): number {
    return this.dashboardStore.enrollment.enrolled;
  }

  get inProgressAmount (): number {
    return this.dashboardStore.enrollment.inProgress;
  }

  get notStartedAmount (): number {
    return this.dashboardStore.enrollment.notStarted;
  }

  get totalPercent (): number {
    return maxPercentage;
  }

  get enrolledPercent (): number {
    return Math.floor((this.enrolledAmount / this.totalAmount) * maxPercentage);
  }

  get inProgressPercent (): number {
    return Math.floor((this.inProgressAmount / this.totalAmount) * maxPercentage);
  }

  get notStartedPercent (): number {
    return Math.floor((this.notStartedAmount / this.totalAmount) * maxPercentage);
  }

  get totalEnrolledPercentage (): number {
    if (this.totalAmount === 0) {
      return 0;
    }

    return Math.floor(((this.enrolledAmount) / this.totalAmount) * maxPercentage);
  }

  get chartData (): any[] {
    return [
      [ "", "Enrolled", "In Progress", "Not Started" ],
      [
        "",
        { v: this.enrolledPercent, f: this.enrolledAmount },
        { v: this.inProgressPercent, f: this.inProgressAmount },
        { v: this.notStartedPercent, f: this.notStartedAmount } ]
    ];
  }
}
